import React from 'react';
import { Container } from 'react-bootstrap';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import CircledIcon from './CircledIcon';

function CircledIconDemo({ children }: any) {
  return (
    <Container>
      <Container className=" mt-10">
        <h4>Circled Icons</h4>
        <Container className="d-flex justify-content-between align-items-center">
          <CircledIcon icon={light('pie-chart')} />
          <CircledIcon variant="icon-emphasized" icon={light('bed-pulse')} />
          <CircledIcon variant="icon-white" icon={light('bed-pulse')} />
          <CircledIcon variant="icon-blue" icon={light('bed-pulse')} />
          <CircledIcon icon={light('pie-chart')} label="With Label" />
          <CircledIcon
            variant="icon-emphasized"
            icon={light('bed-pulse')}
            label="With Label"
          />
          <CircledIcon
            variant="icon-white"
            icon={light('bed-pulse')}
            label="With Label"
          />
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Circled Icons - small</h4>
        <Container className="d-flex justify-content-between align-items-center">
          <CircledIcon icon={light('pie-chart')} size={'icon-sm'}/>
          <CircledIcon variant="icon-emphasized" icon={light('bed-pulse')} size={'icon-sm'}/>
          <CircledIcon variant="icon-white" icon={light('bed-pulse')} size={'icon-sm'}/>
          <CircledIcon icon={light('pie-chart')} label="With Label" size={'icon-sm'}/>
          <CircledIcon
            variant="icon-emphasized"
            icon={light('bed-pulse')}
            label="With Label"
            size={'icon-sm'}
          />
          <CircledIcon
            variant="icon-white"
            icon={light('bed-pulse')}
            label="With Label"
            size={'icon-sm'}
          />
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Circled Icons With Tooltips</h4>
        <Container className="d-flex justify-content-between align-items-center">
          <CircledIcon
            icon={light('bed-pulse')}
            tooltipPos="left"
            tooltipText="Left tooltip"
          />
          <CircledIcon
            variant="icon-emphasized"
            icon={light('bed-pulse')}
            tooltipPos="right"
            tooltipText="Right tooltip"
          />
          <CircledIcon
            variant="icon-white"
            icon={light('pie-chart')}
            tooltipPos="top"
            tooltipText="Top tooltip"
          />
          <CircledIcon
            icon={light('ellipsis')}
            tooltipPos="bottom"
            tooltipText="Bottom tooltip"
            label="With Label"
          />
          <CircledIcon
            variant="icon-emphasized"
            icon={light('info-circle')}
            tooltipPos="left"
            tooltipText="SOMEWHAT LONG TOOLTIP TEXT: Lorem ipsum"
            label="With Label"
          />
          <CircledIcon
            variant="icon-white"
            icon={light('info-circle')}
            tooltipPos="left"
            tooltipText="REALLY LONG TOOLTIP TEXT: Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum"
            label="With Label"
          />
        </Container>
      </Container>
    </Container>
  );
}

export default CircledIconDemo;
